import { useTranslation } from 'react-i18next';
import { ExternalLink } from 'lucide-react';
import { Section, Container } from '../../ui';
import styles from './BuybackPoweredBy.module.css';

export function BuybackPoweredBy() {
  const { t } = useTranslation('buyback');

  return (
    <Section variant="light">
      <Container>
        <div className={styles.wrapper}>
          <span className={styles.badge}>{t('poweredBy.badge')}</span>
          <span className={styles.logo}>CompaRecycle</span>
          <h3 className={styles.title}>{t('poweredBy.title')}</h3>
          <p className={styles.description}>{t('poweredBy.description')}</p>
          <a
            href="https://www.comparecycle.com/"
            target="_blank"
            rel="noopener noreferrer"
            className={styles.link}
          >
            {t('poweredBy.link')}
            <ExternalLink size={14} strokeWidth={1.5} />
          </a>
        </div>
      </Container>
    </Section>
  );
}
